import { getErrorMessageFromErrorType } from '@flowwai-frontend/shared/utils/common'

import { FilterFieldsConfigType } from '../../types/filterTypes'
import { convertGqlSearchAndMonitoringConfigToFilterFieldsConfigType } from '../../factories'

import { GetSearchAndMonitoringConfigQuery as Query } from './query.generatedTypes'
import { GetSearchAndMonitoringConfigResult } from '@flowwai-frontend/bps-officer-web/graphql'

interface ResponseArgsType {
   data: Query

   onFailure: (
      errorMessage: string,
      data: Query['getSearchAndMonitoringConfig']
   ) => void

   onSuccess?: (onSuccess: FilterFieldsConfigType) => void
}

interface ReturnType {
   handleAPIResponse: (args: ResponseArgsType) => void
}

const useAPIResponseHandler = (): ReturnType => {
   const handleAPIResponse = (args: ResponseArgsType): void => {
      const { getSearchAndMonitoringConfig } = args.data

      switch (getSearchAndMonitoringConfig.__typename) {
         case 'GetSearchAndMonitoringConfigResult': {
            const config = convertGqlSearchAndMonitoringConfigToFilterFieldsConfigType(
               (getSearchAndMonitoringConfig as unknown) as GetSearchAndMonitoringConfigResult
            )

            args.onSuccess?.(config)
            break
         }

         case 'SearchAndMonitoringAccessControlConfigNotFound':
         default: {
            const errorType = getSearchAndMonitoringConfig.__typename
            const errorMessage = getErrorMessageFromErrorType(errorType)

            args.onFailure(errorMessage, getSearchAndMonitoringConfig)
         }
      }
   }

   return { handleAPIResponse }
}

export default useAPIResponseHandler
